import { BrowserRouter as Router, Route, Redirect, Switch } from "react-router-dom";
import axios from 'axios';
import { ethers } from 'ethers'
import { useState, useEffect } from 'react'

import { useAddress } from "./hooks/web3Context";
import { useWeb3Context } from './hooks/web3Context'

import { Landing, Pool } from "./views";

import TopBar from "./components/TopBar/TopBar.jsx";
import Notification from "./components/Notification";
import Footer from "./components/Footer/Footer";
import REITokenABI from './abis/REIToken.json'
import DividendTracker from './abis/REITDividendTracker.json'
import LockABI from './abis/LockABI.json'
import "./style.scss";

import {
  getTokenContract,
  getDividendContract,
  getLockContract,
  getMulticallContract,
  getPairContract,
  multicall
} from './utils/contracts'

import { REI_ADDR, REI_ETH_ADDR, DIVIDEND_ADDR, REI_LOCK } from './abis/address';

let timerid = null;
function App() {

  const account = useAddress();

  const { connect, hasCachedProvider } = useWeb3Context();
  const [notification, setNotification] = useState(null);
  const [tokenInfo, setTokenInfo] = useState({ name: 'REIToken', symbol: 'REIT', decimals: 18, totalSupply: 0 });
  const [pools, setPools] = useState([{}, {}])
  const [projectInfo, setProjectInfo] = useState({});

  async function fetchProjectInfo() {
    try {
      let ethPrice = await axios.get('https://api.etherscan.io/api?module=stats&action=ethprice&apikey=47I5RB52NG9GZ95TEA38EXNKCAT4DMV5RX');
      ethPrice = ethPrice.data.result.ethusd;
      const pairContract = getPairContract();
      const reserves = await pairContract.getReserves();
      const price = reserves[1] * Number(ethPrice) / reserves[0];
      let _dvolume = await axios.get(`https://api.etherscan.io/api?module=account&action=tokentx&address=${REI_ETH_ADDR}&contractaddress=${REI_ADDR}&page=1&offset=400&sort=desc&apikey=47I5RB52NG9GZ95TEA38EXNKCAT4DMV5RX`);
      _dvolume = _dvolume.data.result;
      let volume = 0;
      for (let i = 0; i < _dvolume.length; i++) {
        if (_dvolume[i].to && _dvolume[i].to.toLowerCase() === REI_ADDR.toLowerCase()) continue;
        if (_dvolume[i].timeStamp / 1 < _dvolume[0].timeStamp / 1 - 3600 * 24) {
          break;
        }
        volume += _dvolume[i].value / Math.pow(10, 18);
      }
      setProjectInfo({ price, volume, ethPrice })
    }
    catch (error) {
      console.log(error);
    }
  }
  async function fetchTokenInfo() {

    try {
      let calls = [
        { address: REI_ADDR, name: 'totalSupply', params: [] },
        { address: REI_ADDR, name: 'getNumberOfDividendTokenHolders', params: [] },
      ]
      if (account) calls.push({ address: REI_ADDR, name: 'balanceOf', params: [account] });
      let rawTokenBalances = await multicall(REITokenABI, calls);
      const totalSupply = ethers.utils.formatEther(rawTokenBalances[0][0]);
      const holders = rawTokenBalances[1][0] / 1;
      const balance = account ? ethers.utils.formatEther(rawTokenBalances[2][0]) : null;

      calls = [
        { address: DIVIDEND_ADDR, name: 'totalDividendsDistributed', params: [] },
      ]
      if (account) calls.push({ address: DIVIDEND_ADDR, name: 'withdrawableDividendOf', params: [account] });
      rawTokenBalances = await multicall(DividendTracker, calls);

      const totalReward = ethers.utils.formatEther(rawTokenBalances[0][0]);
      const pendingReward = account ? ethers.utils.formatEther(rawTokenBalances[1][0]) : null;

      setTokenInfo({
        name: 'REIToken',
        symbol: 'REIT',
        decimals: 18,
        totalSupply,
        balance,
        pendingReward,
        holders,
        totalReward
      })
    }
    catch (error) {
      console.log(error);
    }
  }

  async function fetchLockInfo() {

    try {
      const stakingTokenContract = getTokenContract();
      let allowance = 0;
      if (account)
        allowance = await stakingTokenContract.allowance(account, REI_LOCK) / 1;
      let temp = [];
      let calls = [
        { address: REI_LOCK, name: 'performanceFee', params: [] },
        { address: REI_LOCK, name: 'bonusEndBlock', params: [] },
      ]
      let rawTokenBalances = await multicall(LockABI, calls);

      const performanceFee = rawTokenBalances[0][0];
      const bonusEndBlock = rawTokenBalances[1][0] / 1;

      for (let i = 0; i < 2; i++) {
        calls = [
          { address: REI_LOCK, name: 'lockups', params: [i] },
        ]
        if (account) {
          calls = calls.concat([
            { address: REI_LOCK, name: 'pendingReward', params: [account, i] },
            { address: REI_LOCK, name: 'pendingDividends', params: [account, i] },
            { address: REI_LOCK, name: 'userInfo', params: [i, account] },
          ])
        }
        console.log(calls);
        let rawTokenBalances = await multicall(LockABI, calls);
        console.log(rawTokenBalances);
        const lockup = rawTokenBalances[0];
        const pendingReward = account ? Number(ethers.utils.formatEther(rawTokenBalances[1][0])) : null;
        const pendingReflection = account ? Number(ethers.utils.formatEther(rawTokenBalances[2][0])) : null;
        const stakedAmount = account ? Number(ethers.utils.formatEther(rawTokenBalances[3].amount)) : null;
        const rate = lockup.rate / lockup.totalStaked * 36500 * 6426 * 46.37 / 45.67;
        temp.push({
          pendingReward,
          pendingReflection,
          stakedAmount,
          rate,
          performanceFee,
          endBlock: bonusEndBlock / 1 - lockup.lastRewardBlock / 1,
          duration: lockup.duration / 1,
          depositFee: lockup.depositFee / 100,
          withdrawFee: lockup.withdrawFee / 100,
          totalStaked: ethers.utils.formatEther(lockup.totalStaked),
          allowance
        });
      }
      console.log(temp);
      setPools(temp);
    }
    catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    fetchTokenInfo();
    fetchLockInfo();
    fetchProjectInfo()
    if (timerid) {
      clearInterval(timerid);
    }
    timerid = setInterval(function () {
      fetchTokenInfo();
      fetchLockInfo();
      fetchProjectInfo()
    }, 5000)
  }, [account])

  useEffect(() => {
    if (hasCachedProvider()) {
      // then user DOES have a wallet
      connect().then(msg => {
        if (msg.type === 'error') {
          setNotification(msg)
        }
      });

    } else {
      // then user DOES NOT have a wallet
    }

    // We want to ensure that we are storing the UTM parameters for later, even if the user follows links
  }, []);

  return (
    <Router>
      <TopBar setNotification={setNotification} />
      <Switch>

        <Route exact path="/landing">
          <Landing
            account={account}
            setNotification={setNotification}
            projectInfo={projectInfo}
            tokenInfo={tokenInfo}
          />
        </Route>

        <Route exact path='/pool'>
          <Pool
            account={account}
            setNotification={setNotification}
            pools={pools}
            tokenPrice={projectInfo.price}
            ethPrice={projectInfo.ethPrice}
            tokenInfo={tokenInfo}
          />
        </Route>
        <Route exact path="/">
          <Redirect to="landing" />
        </Route>
      </Switch>
      <Footer />
      <Notification data={notification} />

    </Router>
  );
}

export default App;
